import React from 'react';
import WebLayout from '../layouts/WebLayout';

const StorePromotionPage = () => {
    return (
        <WebLayout>
            <div className="min-h-screen bg-white">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
                    {/* 메인 타이틀 */}
                    <div className="text-center mb-20">
                        <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
                            홍보, 이제는 <span className="text-amber-500">밥친구와 함께</span>
                        </h1>
                    </div>

                    {/* 1행 - 여러 명 방문 */}
                    <div className="grid md:grid-cols-2 gap-12 items-center mb-20">
                        <div className="space-y-6">
                            <h2 className="text-3xl font-bold text-amber-500">한 번에 여러 명, 밥친구 모임으로 방문</h2>
                            <p className="text-lg text-gray-700 leading-relaxed">
                                혼자 오는 손님이 아니라<br/>
                                여럿이 함께 찾는 테이블이 많아져요
                            </p>
                        </div>
                        <div className="aspect-[4/3] rounded-lg overflow-hidden">
                            <img
                                src="/images/web4_1.png"
                                alt="여러 명 방문 이미지"
                                className="w-full h-full object-cover"
                            />
                        </div>
                    </div>

                    {/* 2행 - 사장님 안심 (일반 카드) */}
                    <div className="grid md:grid-cols-2 gap-12 items-center mb-20">
                        <div className="space-y-6">
                            <h2 className="text-3xl font-bold text-amber-500">쌀 시스템으로 사장님도 안심</h2>
                            <p className="text-lg text-gray-700 leading-relaxed">
                                밥친구는 예약 후 무단 불참을 막기 위해<br/>
                                모임 참여 시 쌀(보증금)을 걷어요.
                            </p>
                        </div>
                        <div className="aspect-[4/3] rounded-lg overflow-hidden">
                            <img
                                src="/images/web4_2.png"
                                alt="사장님 안심 이미지"
                                className="w-full h-full object-cover"
                            />
                        </div>
                    </div>

                    {/* 3행 - 광고 효과 */}
                    <div className="grid md:grid-cols-2 gap-12 items-center mb-20">
                        <div className="space-y-6">
                            <h2 className="text-3xl font-bold text-amber-500">명확하게 보이는 광고 효과</h2>
                            <p className="text-lg text-gray-700 leading-relaxed">
                                가게에서 열린 모임 개수를<br/>
                                사장님이 직접 확인할 수 있어요
                            </p>
                        </div>
                        <div className="aspect-[4/3] rounded-lg overflow-hidden">
                            <img
                                src="/images/web4_3.png"
                                alt="광고 효과 이미지"
                                className="w-full h-full object-cover"
                            />
                        </div>
                    </div>

                    {/* 4행 - 동네 집중 노출 (일반 카드) */}
                    <div className="grid md:grid-cols-2 gap-12 items-center mb-20">
                        <div className="space-y-6">
                            <h2 className="text-3xl font-bold text-amber-500">우리 동네에서 집중적으로 노출</h2>
                            <p className="text-lg text-gray-700 leading-relaxed">
                                우리 가게와 가까운<br/>
                                동네 사람들에게 자주 노출돼요
                            </p>
                        </div>
                        <div className="aspect-[4/3] rounded-lg overflow-hidden">
                            <img
                                src="/images/web4_4.png"
                                alt="동네 집중 노출 이미지"
                                className="w-full h-full object-cover"
                            />
                        </div>
                    </div>

                    {/* CTA 섹션 */}
                    <div className="text-center">
                        <div className="inline-block p-8">
                            <h3 className="text-3xl font-bold text-amber-500 mb-4">밥친구와 함께 성장하세요!</h3>
                            <p className="text-lg text-gray-700">
                                우리 가게도 밥친구 제휴매장이 되어보세요
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </WebLayout>
    );
};

export default StorePromotionPage;
